import { render, staticRenderFns } from "./IndexDeactive.vue?vue&type=template&id=3cf1c7c6&scoped=true"
import script from "./IndexDeactive.vue?vue&type=script&lang=js"
export * from "./IndexDeactive.vue?vue&type=script&lang=js"
import style0 from "./IndexDeactive.vue?vue&type=style&index=0&id=3cf1c7c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf1c7c6",
  null
  
)

export default component.exports